import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//Redux
import { useDispatch } from "react-redux";

//Components
import Layout from "../../../../Layout/Layout";
import CustomerConstants from "../../../../common/CustomerConstants";

import DeleteMaterialV2 from "./DeleteMaterialV2";
import CatalogProductDetailModalV2 from "../Common/CatalogModal/CatalogProductDetailModalV2";

import MaterialHBModalV2 from "./MaterialHBModalV2";

import { SearchField } from "../../../../Components/formElements/SearchField";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import MultiColumnFilter from "../../../../Components/MultiColumnFilter/MultiColumnFilter";
import { addMaterial } from "../../../../redux/feature/customer_app/customerSlice";
import ItemService from "../../../../services/customer_appCommonService";
import CommonFilterCustomerV2 from "../Common/CommonFilterCustomerV2";

// import { formatDate } from "../../../../common/Validations";

const MaterialV2 = () => {
  localStorage.setItem("menu", "Master");
  localStorage.setItem("submenu", "Material Master");

  const dispatch = useDispatch();

  // let materialData = useSelector((state) => state?.customer?.material?.data); // User Details from Store
  // console.log(">>materialData",materialData)
  // let materialTable = useSelector(
  //   (state) => state?.customerV1?.material?.pagination
  // );
  const [materialData, setMaterialData] = useState();
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [getNewPerPage, setNewPerPage] = useState(10);

  const [modalDeleteMaterial, setModalDeleteMaterial] = useState(false);
  const [modalShowAddProduct, setModalShowAddProduct] = useState(null);
  const [modalShowDetailProduct, setModalShowDetailProduct] = useState(false);

  const [isCardVisible2, setCardVisible2] = useState(true);

  const [getData, setData] = useState();
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  // eslint-disable-next-line
  const [getFileViewData, setFileViewData] = useState(null);
  // const target = useRef(null);

  const [getFilter, setFilter] = useState({});

  const columns = [
    // {
    //   name: "Material",
    //   selector: (row) => row.productName || "--",
    //   cell: (row) => (
    //     <div
    //       className="flex justify-center items-center cursor-pointer"
    //       onClick={() => showAddProduct("DETAILS", row.documentNumber, row)}
    //     >
    //       <div className="w-75">
    //         <ShowUploadImageV2 fileid={row?.materialImage} />
    //       </div>
    //     </div>
    //   ),
    //   sortable: true,
    //   width: "140px",
    // },
    {
      name: "Material",
      id: "materialDescription",
      // id1:"materialDescription",
      // dropDown: true,
      selector: (row) => row.productName || "--",
      cell: (row) => (
        // <div className="d-flex justify-content-center w-50 align-items-center cursor-pointer">

        <div
          className="flex justify-center items-center cursor-pointer"
          onClick={() => showAddProduct("DETAILS", row.documentNumber, row)}
        >
          <div className="ms-2">
            <p className="m-0 p-0 pt-1 fw-bold">{row?.materialCode} </p>

            <p className="m-0 p-0 pt-1 fw-bold text-success">
              {row.materialDescription}{" "}
            </p>
          </div>
        </div>
      ),
      sortable: true,
      width: "300px",
    },
    {
      name: "UOM",
      selector: (row) => row.uOM || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "Per Bag/Box",
      selector: (row) => row.perBagBox || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0  fw-bold text-primary">{row?.perBagBox} </p>
          <p className="m-0 p-0 pt-1  ">{row?.unitIn} </p>
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "CGST%",
      selector: (row) => row.cgst || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "SGST%",
      selector: (row) => row.sgst || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "Attachments",
      selector: (row) => row.materialAttachments,
      cell: (row) => (
        <div
          style={{ width: "100%" }}
          className="d-flex justify-content-center cursor-pointer"
          // onClick={()=>showViewInvoice(row)}
          // onClick={() => handlePrintWithData(row)}
        >
          <img
            src="assets/img/newIcons/attached-file.png"
            alt="attachments"
            style={{ width: "25px" }}
            className="mt-1"
          />
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Active",
      selector: (row) => row.activeInactive,
      cell: (row) => (
        <div className="form-check form-switch">
          <input
            className="form-check-input custom-switch"
            type="checkbox"
            role="switch"
            id={`switch-${row.local_id}`}
            checked={row.activeInactive === true}
            // onChange={(event) => handleCheckboxChange(row.local_id, event)}
          />
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Edit",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <div>
          <button
            title="Edit"
            className="btn d-flex align-items-center w-100"
            // onClick={DeleteMaterial}
            onClick={() => showAddProduct("EDIT", row.documentNumber, row)}
          >
            <i class="bi bi-pencil-square pe-2"></i>{" "}
            {/* <sapn className="m-0 p-0 pt-1">Edit </sapn> */}
          </button>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    // {
    //   name: "Delete",
    //   selector: (row) => row.purchaseType || "--",
    //   cell: (row) => (
    //     <div>
    //       <button onClick={() => deleteMaterial(row)}>
    //         {/* <i class="bi bi-trash3"></i> */}
    //         <i className="bi bi-trash text-danger fs-4" />
    //       </button>
    //     </div>
    //   ),
    //   sortable: true,
    //   width: "200px",
    // },
  ];

  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };

  // const handleViewFile = (fileAttachmentId) => {
  //   setFileViewData(fileAttachmentId);
  //   setShowFileViewModal(true);
  // };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  // eslint-disable-next-line
  const deleteMaterial = (data) => {
    setModalDeleteMaterial(true);
    setData(data);
    dispatch(addMaterial(data.documentNumber));
  };
  const [getPropsData, setPropsData] = useState();
  const showAddProduct = (mode, materialnumber, data) => {
    setModalShowAddProduct(mode);
    setPropsData(data);

    if (mode === "EDIT") {
      dispatch(addMaterial(materialnumber));
    } else if (mode === "DETAILS") {
      dispatch(addMaterial(materialnumber));
    } else {
      dispatch(addMaterial(""));
    }
  };

  const hideModal = () => {
    setModalDeleteMaterial(false);
    setModalShowAddProduct(null);
    setModalShowDetailProduct(false);
  };
  // eslint-disable-next-line
  const [getLoading, setLoading] = useState();
  const [getTotal, setTotal] = useState();

  const getMaterialList = async (obj) => {
    try {
      setLoading(true);
      await ItemService.generateCustomerQuery(obj).then((item) => {
        if (item?.status === 200) {
          setMaterialData(item?.data);
          setTotal(item?.total);
        }
      });
    } catch (error) {
      console.log("Failed to send invitation:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const obj = {
      queryName: "Get_ALL_Materials",
      page: 1,
      per_page: 10,
    };
    getMaterialList(obj);
  }, []);

  const handlePageChange = (page) => {
    // let obj = {
    //   queryName: "",
    //   page: page,
    //   per_page: getNewPerPage,
    // };
    // dispatch(getMaterialList(obj));

    const obj = {
      queryName: "Get_ALL_Materials",
      page: page,
      per_page: getNewPerPage,
      rowFilter: {
        $and: [getFilter],
      },
    };

    getMaterialList(obj);
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    // let obj = {
    //   queryName: "",
    //   page: page,
    //   per_page: newPerPage,
    // };
    // dispatch(getMaterialList(obj));

    const obj = {
      queryName: "Get_ALL_Materials",
      page: page,
      per_page: newPerPage,
      rowFilter: {
        $and: [getFilter],
      },
    };
    getMaterialList(obj);

    setNewPerPage(newPerPage);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    // let obj = {
    //   queryName: "",
    //   page: 1,
    //   per_page: 10,
    //   searchTerm: getCommonSearchTxt,
    // };
    // dispatch(getMaterialList(obj));

    let obj = {
      queryName: "Get_ALL_Materials",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    getMaterialList(obj);
  };
  // const [data, setDataFilter] = useState();
  const [filterShow, setFilterShow] = useState(false);

  // const handleFilterData = async (filters) => {
  //   const obj = {
  //     queryName: "",
  //     page: 1,
  //     per_page: 10,
  //     searchTerm: "",
  //     rowFilter: filters.length > 0 ? { $and: filters } : {},
  //   };

  //   // dispatch(getQtnJobList(obj));
  //   dispatch(getMaterialList(obj));

  //   // console.log(obj)
  // };

  // const columnsForFilter = columns
  //   .filter((col) => col.id || col.selectorKey)
  //   .map((col) => ({
  //     name: col.name,
  //     selectorKey: col.id || col.selectorKey,
  //     dropDown: col.dropDown || false,
  //     range: col.range || false,
  //     month: col.month || false,
  //   }));

  const handleAdvanceSearchFuncApi = async (filters) => {
    let obj = {
      queryName: "Get_ALL_Materials",
      module: "",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: {
        $and: [filters],
      },
    };
    setFilter(filters);
    getMaterialList(obj);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle"> Material Master</h2>
                <p className="subText">Material</p>
              </Col>
              <Col
                xs={12}
                md={3}
                lg={3}
                className="d-flex justify-content-end mt-3"
              >
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={12} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />
            {filterShow && (
              <CommonFilterCustomerV2
                getfiltereddata={columns}
                cancelAction={() => setFilterShow(!filterShow)}
                onSubmit={(filters) => {
                  // console.log(">>Received filters from child:", filters);
                  // const filterData=[filters]
                  handleAdvanceSearchFuncApi(filters);
                  // You can now use the filters here
                }}
              />
            )}
            {/* material */}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-down"
                            : "bi-chevron-right"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">MD</span>
                    </Col>
                    <Col xs={6} md={4} lg={4}>
                      <span className="headerTitle">Material Details</span>
                      <span className="subHeaderTitle">Material</span>
                    </Col>

                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      {/*     <Col xs={3} md={3} lg={3} className="">
                        <button className="btnTable d-flex justify-content-center">
                          <p className="m-0 me-2">
                            {" "}
                            <span className="mr-2">
                              <i class="bi bi-upload"></i>
                            </span>
                            Upload
                          </p>
                        </button>
                      </Col> */}
                      <Col xs={3} md={3} lg={3} className="">
                        <button
                          className="btnTable d-flex justify-content-center"
                          onClick={() => showAddProduct("CREATE")}
                        >
                          <p className="m-0 me-2">Material Creation</p>
                          {/* <i class="bi bi-plus-square"></i> */}
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={materialData}
                          // progressPending={purchaseOrderData?.status}
                          paginationRowsPerPageOptions={
                            CustomerConstants.ROW_PER_PAGE
                          }
                          pagination
                          paginationServer
                          paginationTotalRows={getTotal}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <DeleteMaterialV2
        show={modalDeleteMaterial}
        onHide={() => hideModal()}
        data={getData}
        // dropdownData={getAccountGroup}
      />
      <MaterialHBModalV2
        show={modalShowAddProduct}
        onHide={() => hideModal()}
        data={getPropsData}
        refreshMaterialList={getMaterialList}
      />
      <CatalogProductDetailModalV2
        show={modalShowDetailProduct}
        onHide={() => hideModal()}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default MaterialV2;
